import {
  GraphQLID,
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLBoolean
} from 'graphql'
import {
  VulnerabilitySeverity,
  vulnerabilitySeverityType
} from './vulnerability'

export interface VulnerabilityUpdateSeverityMutationArgs {
  readonly input: {
    readonly organizationID: string
    readonly vulnerabilityID: string
    readonly severity: VulnerabilitySeverity
    readonly overrideAll: boolean
  }
}

export const vulnerabilityUpdateSeverityMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'VulnerabilityUpdateSeverityMutationArgs',
      description:
        'Parameters that describe how to update a vulnerability severity',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization for the vulnerability being updated',
          type: new GraphQLNonNull(GraphQLID)
        },
        vulnerabilityID: {
          description: 'The ID of the vulnerability being updated',
          type: new GraphQLNonNull(GraphQLID)
        },
        severity: {
          description: 'The new severity of the vulnerability',
          type: new GraphQLNonNull(vulnerabilitySeverityType)
        },
        overrideAll: {
          description:
            'Whether or not to override the severity of all vulnerabilties of the same type',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}
